import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActivePurchasePlan } from '@aptitude/shared';

@Injectable()
export class PurchasePlanningNavButtonsService {
  #saveDisabled$ = new BehaviorSubject(true);
  saveDisabled$ = this.#saveDisabled$.asObservable();

  #saveClicked$ = new Subject();
  saveClicked$ = this.#saveClicked$.asObservable();

  #continueClicked$ = new Subject();
  continueClicked$ = this.#continueClicked$.asObservable();

  #unlockPlanClicked$ = new Subject();
  unlockPlanClicked$ = this.#unlockPlanClicked$.asObservable();

  #updateHeader$ = new Subject<ActivePurchasePlan>();
  updateHeader$ = this.#updateHeader$.asObservable();

  #lockDisabled$ = new BehaviorSubject(false);
  lockDisabled$ = this.#lockDisabled$.asObservable();

  saveClicked() {
    this.#saveDisabled$.next(true);
    this.#saveClicked$.next(null);
  }

  continueClicked() {
    this.#continueClicked$.next(null);
  }

  unlockPlanClicked() {
    this.#unlockPlanClicked$.next(null);
  }

  updateHeader(activePurchasePlan: ActivePurchasePlan) {
    this.#updateHeader$.next(activePurchasePlan);
  }

  setLockDisabled(value: boolean) {
    this.#lockDisabled$.next(value);
  }
}
